import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IChangeCallback } from '../../../_entities';
import {
    IDemarcationListTemplate, IDemarcationListTemplateRow, IDemarcationListTemplateColumn,
    IDemarcationListAnswers, IDemarcationListAnswersRow, IDemarcationListAnswersColumn
} from '../../../_entities/demarcation';
import { IDataChangeCallback } from '../../../_entities/data';

@Component({
	selector: 'demarcation-list-template',
	template: require('./demarcation-list-template.template.html')
})
export class DemarcationListTemplateComponent {

	@Input()
	listAnswers: IDemarcationListAnswers;
	@Input()
	listTemplate: IDemarcationListTemplate;
	@Output()
	changeCallback = new EventEmitter<IDataChangeCallback<any>>();

	nullValue = null;
	isNullOrEmpty = value => !(typeof value === "string" && value.length > 0);

	private pListAnswers: IDemarcationListAnswers;

	get answers(): IDemarcationListAnswers {
		if (this.pListAnswers == null) {
			this.initAnswers();
		}
		if (this.listAnswers != null) {
			this.pListAnswers = this.listAnswers;
		}
		return this.pListAnswers;
	}

	get rows(): IDemarcationListTemplateRow[] {
		if (this.listTemplate == null) {
			return null;
		}
		return this.listTemplate.structure.rows;
	}

	get columns(): IDemarcationListTemplateColumn[] {
		if (this.listTemplate == null) {
			return null;
		}
		return this.listTemplate.structure.columns;
	}

	getRow(rowIndex: number): IDemarcationListAnswersRow {
		return this.answers.rows[rowIndex];
	}

	getRowComment(rowIndex: number): string {
		const row = this.getRow((rowIndex));
		return row != null && row.hasOwnProperty("comment") ? row.comment : null;
	}

	getColumn(rowIndex: number, colIndex: number): IDemarcationListAnswersColumn {
		const row = this.answers.rows[rowIndex];
		return row != null && row.hasOwnProperty("columns") ? row.columns[colIndex] : { value: null };
	}

	getColumnValue(rowIndex: number, colIndex: number) {
		const column = this.getColumn(rowIndex, colIndex);
		return column != null && column.hasOwnProperty("value") ? column.value : null;
	}

	onChange(fieldname: string, obj: any, event: IChangeCallback<any>) {

		if (!obj.hasOwnProperty(fieldname)) {
			throw new Error(`Fieldname ${fieldname} does not exists on object`);
		}
		obj[fieldname] = event.newValue;

		event.resolve();

		this.emitAnswers();
	}


	onHeaderAnswerChange(row: number, col: number, value: any) {

		//set the self and following while row has no header..?!

		var i = 0;

		do {
			var obj = this.getColumn(row, col);

			obj['value'] = value;

			//setTimeout(() => this.onAnswerChange('value', column, value), i * 300);
			row++;
			i++;

		} while (this.rows[row] && !this.rows[row].header); 
		this.emitAnswers();
}


onAnswerChange(fieldname: string, obj: any, value: any) {

        if (!obj.hasOwnProperty(fieldname)) {
            throw new Error(`Fieldname ${fieldname} does not exists on object`);
        }
        obj[fieldname] = value;

        this.emitAnswers();

    }

    emitAnswers() {
        this.changeCallback.emit({
            fieldname: "demarcationListAnswers",
            oldValue: null,
            newValue: this.answers,
            reject: (message: string) => {
                if (message != null) {
                    alert(`Something went wrong...\n\nMessage: ${message}`);
                }
            },
            resolve: () => {
            }
        });        
    }

    initAnswers(): void {

        const colLength = this.columns.length;
        const rowLength = this.rows.length;
        const answerRows = new Array(rowLength);
        for (let r = 0; r < rowLength; r++) {
            const columns = new Array(colLength);
            for (let c = 0; c < colLength; c++) {
                columns[c] = { value: null };
            }
            const row: IDemarcationListAnswersRow = { columns: columns, comment: null, documentUrl: null, documentId: null };
            answerRows[r] = row;
        }
        this.pListAnswers = { rows: answerRows };
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/demarcation/demarcation-list-template.component.ts